import { render, staticRenderFns } from "./GalleryCopy.vue?vue&type=template&id=6b62a637&scoped=true&"
import script from "./GalleryCopy.vue?vue&type=script&lang=js&"
export * from "./GalleryCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b62a637",
  null
  
)

export default component.exports